import type { RoadSectionId } from '../../domain/Reference';
import { createCommand } from '../../utils';
import { selectionFocusRequested } from '../state';
import { ExtendSelectionCommand } from './ExtendSelectionCommand';
import { SelectRoadSectionCommand } from './SelectRoadSectionCommand';

export type SearchPick =
    | { kind: 'axis'; firstSectionId: RoadSectionId }
    | { kind: 'section'; sectionId: RoadSectionId };

// Picking a search result: a section is selected and shown; an axis selects all its sections (as the
// "Tout l'axe" action does) and shows them.
export const SelectSearchResultCommand = createCommand<SearchPick>(
    'MAP_V2/SELECT_SEARCH_RESULT',
    async (pick, { dispatch }) => {
        if (pick.kind === 'axis') {
            await dispatch(ExtendSelectionCommand({ kind: 'axis', baseId: pick.firstSectionId }));
        } else {
            await dispatch(SelectRoadSectionCommand(pick.sectionId));
            dispatch(selectionFocusRequested());
        }
    },
);
